export const about = {
    name : 'Jay Patel',
    profile : '@Developer',
    linkedIn : {
        title : 'LinkedIn',
        link : 'https://www.linkedin.com/in/jay-patel-93b394155/',
    },
    github : {
        title : 'GitHub',
        link : 'https://github.com/Jay1112'
    }
};